import { render, staticRenderFns } from "./AddVideoShowcaseModal.vue?vue&type=template&id=e671fc1c&"
import script from "./AddVideoShowcaseModal.vue?vue&type=script&lang=js&"
export * from "./AddVideoShowcaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports